/**
 * futureshop用
 */

// 商品詳細のサイズ画像掲載JS
export function fs_item_sizedata() {
  document.addEventListener("DOMContentLoaded", function() {
    const targetImages = document.querySelectorAll(".targetImage");

    // targetImagesが存在する場合のみ処理を実行
    if (targetImages.length > 0) {
      targetImages.forEach(targetImage => {
        const src = targetImage.src;

        if (src.includes("imgpass-last")) {
          const newSrc = document.querySelector(".fs-c-productCarouselMainImage__carousel .slick-list .slick-track .slick-slide:last-child img").src;
          targetImage.src = newSrc;
        } else {
          const match = src.match(/imgpass-(\d+)/);
          if (match) {
            const index = parseInt(match[1], 10);
            if (index >= 1 && index <= 40) {
              const newSrc = document.querySelector(`.fs-c-productCarouselMainImage__carousel .slick-list .slick-track .slick-slide:nth-child(${index}) img`).src;
              targetImage.src = newSrc;
            }
          }
        }
      });
    }
  });

}
